import React, {Component} from 'react'
import CInput from '@/components/CForm/CInput'
import CSelect from "../../components/CForm/CSelect";
import CRadio from "../../components/CForm/CRadio";
import CButton from '@/components/CButton'
import { withRouter} from 'react-router-dom'
import { connect} from 'react-redux'
import { bindActionCreators, compose} from 'redux'
import {dpeallcitylist} from "../../utils/citylist";
import './index.scss'
import {Modal, message, Radio, Card, Upload, Button, Progress, Descriptions} from "antd";
import {scodeLibrary,fixToken,registerUser,museumnamecheck} from "../../servers/commonApi";
import upload from '@/assets/images/upload.png'
import {getuploadfileparams, removepic} from "../../servers/menu";
import Axios from "axios";
import translate from "swiper/src/components/core/translate";
const axios = Axios.create();

class Login extends Component{
  onRef(ref){this.child = ref}
  constructor(props) {
    super(props);
    this.changHandler = this.changHandler.bind(this);
    this.registerHandler = this.registerHandler.bind(this);
    this.handleCancel = this.handleCancel.bind(this)
    this.chooseLibrary = this.chooseLibrary.bind(this)
    this.selectLibraty = this.selectLibraty.bind(this)
  }
  state = {
    code:'',
    name:'',
    province:'',
    provincename:'',
    area:'',
    areaname:'',
    id:'',
    newlevel:3,
    holder:'',
    adminname:'',
    adminphone:'',
    admindepartment:'',
    adminposition:'',
    isModalOpen:false,
    checked:false,
    level:[
      {name:'一级',value:1},
      {name:'二级',value:2},
      {name:'三级',value:3},
    ],
    provinve:dpeallcitylist,
    library:[],
    areaarr:[],
    success:false,
    choosetypes:1,
    typeArr:[
      {name:'统一社会信用代码',value:1},
      {name:'博物馆名称',value:2},
    ],
    currentlevel:'',
    xingzhi:'',
    message:'',
    files:[],
    uploads: {
      accept: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif',
      disabled: false,
      name: 'file',
      showUploadList: false,
      defaultFileList: [],//{uid: '', name: '', url: ''}
      fileList: [],
      limit: 20,//限制上传数量 默认无限制
      size: 1024*1024*30,//默认限制大小为2M
    },
    change:false
  };

  gotoLogin(){
    this.props.history.push({
      pathname: '/login'
    });
  }

  changHandler(value, type){
    if (type === 'name') {
      this.setState({
        change: true
      })
    }
    this.setState({
        [type]: value
    })
  }

  selectLibraty(){
    if (this.state.name === '' || !this.state.change) {
      this.setState({
        currentlevel:'',
        xingzhi:'',
        province:'',
        area:'',
        provincename:'',
        areaname:'',
        id:'',
        library:[]
      })
      return
    }
    const params = {
      name:this.state.name
    }
    museumnamecheck(params).then(res=>{
      if (res.statecode !== 0) {
        message.error(res.statemessage)
        this.setState({
          name:''
        })
      } else {

        if (res.records.length === 1) {
          this.setState({
            id:res.records[0].id,
            library:res.records
          })
          this.chooseLibrary(res.records[0])
        } else {
          this.setState({
            library:res.records,
            change:false
          })
        }
      }
    })
  }

  chooseLibrary(value){
    for (let i=0;i<this.state.library.length;i++){
      if (this.state.library[i].id === value.id){
        this.setState({
          currentlevel:this.state.library[i].level,
          xingzhi:this.state.library[i].nature,
          province:this.state.library[i].provinceid,
          area:this.state.library[i].regionid,
          provincename:this.state.library[i].province,
          areaname:this.state.library[i].region,
          id:value.id,
          name:value.name.split('-')[0],
          library:[]
      })
        break
      }
    }
  }

  downloadquestion(){
    window.location.href = '/fc/down/定级评估系统注册问题汇总.pdf'
  }

  registerHandler(){
    if (this.state.code === '') {
      message.error('请输入请输入统一社会信用代码')
      return
    }
    if (this.state.id === '') {
      message.error('请输入博物馆名称')
      return
    }
    const params = {
      id:this.state.id,
      socialcode:this.state.code,
      newlevel:this.state.newlevel,
      holder:this.state.holder,
      adminname:this.state.adminname,
      admindepartment:this.state.admindepartment,
      adminposition: this.state.adminposition,
      adminphone:this.state.adminphone
    }
    registerUser(params).then(res=>{
      if (res.statecode === 0) {
        this.setState({
          success:true,
          message:res.statemessage,
          isModalOpen: true,
        })
      } else {
        this.setState({
          success:false,
          message:res.statemessage,
          isModalOpen: true,
        })
      }
    })
  }

  handleCancel(){
    this.setState({
      isModalOpen: false
    })
    if (this.state.success){
      this.props.history.push({
        pathname: '/login',
      });
    }
  }

  removeFile(file){
    Modal.confirm({
      content: '确认移除该附件',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.confirmModal(file)
      }
    });
  }

  confirmModal(file){
    const params = {
      fileid:file.fileid
    }
    removepic(params).then(res=>{
      if (res.statecode === 0) {
        message.success('移除成功')
        const result = JSON.parse(JSON.stringify(this.state.files))
        result.forEach((item,index)=>{
          if (item.fileid === file.fileid) {
            result.splice(index,1)
          }
        })
        this.setState({
          files:result
        })
      } else {
        message.error(res.statemessage)
      }
    })
  };
  async beforeUpload(file){
    if (this.state.id === '') {
      message.error('请输入博物馆名称')
      return false
    }
    let name = file.name;
    let currentFileType = name.split('.').pop();
    let fileType = this.state.uploads.accept.split(',');
    if(fileType.includes(`.${currentFileType}`)){
      let params = {}
      params = {
        annexcode: 4001,
        dataid:this.state.id,
        fname:name,
        type:'1F15'
      }
      await getuploadfileparams(params).then(res=>{
        if(res.statecode === 0) {
          let formdata = new FormData()
          formdata.append('name', file.name)
          formdata.append('key', res.records[0].key)
          formdata.append('policy', res.records[0].policy)
          formdata.append('OSSAccessKeyId', res.records[0].OSSAccessKeyId)
          formdata.append('success_action_status', res.records[0].success_action_status)
          formdata.append('callback', res.records[0].callback)
          formdata.append('signature', res.records[0].signature)
          formdata.append('x:refid', res.records[0]['x:refid'])
          formdata.append('file', file)
          axios.post(
              res.records[0].host,
              formdata,
              {
                headers:
                    { 'Content-Type': 'multipart/form-data' },
              }
          )
              .then(res => {
                console.log(res);
                if (res.status === 200 && res.data.statecode === 0) {
                  message.success('上传成功')
                  const result = this.state.files
                  result.push(res.data.records[0])
                  this.setState({
                    files:result
                  })
                } else {
                  message.error('上传失败')
                }
              })
              .catch(error => {
                message.error('上传失败')
              })
        } else {
          message.info(res.statemessage);
        }
      })
      return false;
    }else{
      message.info('请上传指定的文件类型');
    }
  }
  componentDidMount(){}

  render(){
    return (
      <div className='register'>
        <div className='register-title' onClick={()=>{this.gotoLogin()}}>
          博物馆定级评估系统
        </div>
        <div className='flex register-content'>
          <div className='register-form'>
            <div className='register-form-content'>
              <div className="register-form-content-item">
                <span>社会信用代码<span style={{color:'red'}}>(*)</span>:</span>
                <div>
                  <CInput value={this.state.code} placeholder='请输入统一社会信用代码' onChange={(value)=>this.changHandler(value, 'code')}/>
                </div>
              </div>
              <div className="register-form-content-item">
                <span>博物馆名称<span style={{color:'red'}}>(*)</span>:</span>
                <div className='chooseLibrary'>
                  <CInput value={this.state.name}
                          placeholder='请输入博物馆名称'
                          onChange={(value)=>this.changHandler(value, 'name')}
                          onBlur={()=>this.selectLibraty()}/>
                  {this.state.library.length>1 && <ul>
                    {this.state.library.map(item=>{
                      return <li onClick={()=>{this.chooseLibrary(item)}}>{item.name}-{item.province}-{item.region}-{item.city}</li>
                    })}
                  </ul>}
                </div>
              </div>
              <div className="register-form-content-item">
                <span>所处省份:</span>
                <div>
                  {this.state.provincename}
                </div>
              </div>
              <div className="register-form-content-item">
                <span>所处地区:</span>
                <div>
                  {this.state.areaname}
                </div>
              </div>

              <div className="register-form-content-item">
                <span>博物馆性质:</span>
                <div>{this.state.xingzhi}</div>
              </div>
              <div className="register-form-content-item">
                <span>现有等级:</span>
                <div style={{flex:'1'}}>{this.state.currentlevel}</div>
              </div>
              <div className="register-form-content-item">
                <span>拟申请等级<span style={{color:'red'}}>(*)</span>:</span>
                <div>
                  <CRadio value={this.state.newlevel} options={this.state.level} style={{flex:'1'}} onChange={(value)=>this.changHandler(value, 'newlevel')}></CRadio>
                </div>
              </div>
              <div className="register-form-content-item">
                <span>填报负责人姓名<span style={{color:'red'}}>(*)</span>:</span>
                <div>
                  <CInput value={this.state.adminname} placeholder='请输入管理员姓名'  onChange={(value)=>this.changHandler(value, 'adminname')}/>
                </div>
              </div>
              <div className="register-form-content-item">
                <span>手机号码<span style={{color:'red'}}>(*)</span>:</span>
                <div>
                  <CInput value={this.state.adminphone} placeholder='请输入管理员手机号码'  onChange={(value)=>this.changHandler(value, 'adminphone')}/>
                </div>
              </div>
              <div className="register-form-content-item">
                <span>部门:</span>
                <div>
                  <CInput value={this.state.admindepartment} placeholder='请输入管理员部门'  onChange={(value)=>this.changHandler(value, 'admindepartment')}/>
                </div>
              </div>
              <div className="register-form-content-item">
                <span>职务:</span>
                <div>
                  <CInput value={this.state.adminposition} placeholder='请输入管理员职务'  onChange={(value)=>this.changHandler(value, 'adminposition')}/>
                </div>
              </div>
              <div style={{margin:'20px 0',borderTop:'1px solid #bebebe',borderBottom:'1px solid #bebebe',padding:'10px 0'}}>
                博物馆名称和社会信用代码须与“全国博物馆年度报告信息系统”保持一致。如有任何不一致，请将说明文件（相关情况文字说明及变更前后信息、法人证书、相关主管部门批准文件等证明文件）和填报负责人姓名、电话等一同发送至邮箱：<span style={{color:'#1e9fff'}}>bwgpg_cma@sina.com</span>
              </div>
                <div className="register-form-content-item1">

                  <div className='file-blocks'>
                    <div className='file-name'>
                      如无统一社会信用代码，请填0，并上传相关证明资料（如法人证书、相关主管部门批准文件、填报负责人姓名、电话等）。
                    </div>
                    <div className='file-operate'>
                      <Upload
                          {...this.state.uploads}
                          beforeUpload={(file, fileList) => this.beforeUpload(file)}
                          onRemove={(file) => this.removeFile(file)}
                      >
                        <div><Button type='primary'><img src={upload} alt="" style={{width:'20px'}}/>上传文件</Button></div>
                      </Upload>
                    </div>
                  </div>
                  {this.state.files.map(item2=>{
                    return <div className='file-blocks'>
                      <div className='file-name'>
                        {item2.filename}
                      </div>
                      <div className='file-operate'>
                        <Button type="link" onClick={()=>{this.removeFile(item2)}} style={{color:'red',marginLeft:'-20px'}}>
                          删除
                        </Button>
                      </div>
                    </div>
                  })}
            </div>
                <CButton className='register-button' size='larger' block type='primary' onClick={()=>this.registerHandler()}>注册</CButton>
            </div>
            <div style={{position:'relative',marginTop:'20px'}}>
               <span style={{position:'absolute',fontSize:'16px',fontWeight:'bold',color:'orange',cursor:'pointer',borderBottom:'2px solid orange',marginLeft:'20px'}} onClick={this.downloadquestion}>常见问题解答</span>
               <span style={{position:'absolute',left:'50%',transform:'translate(-50%)'}} >技术支持：15801346528</span>
            </div>
          </div>
        </div>

        <Modal title="提示"
               visible={this.state.isModalOpen}
               onCancel={this.handleCancel}
               footer={[]}
        >
            <div className='loginlist'>
              {this.state.message}
            </div>
        </Modal>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {}
};

const mapDispatchToProps = (dispatch) => {
  return {}
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Login);
